export default "__VITE_ASSET__Z$t8Y4T___"